import React from 'react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = 'h-8' }) => {
  return (
    <img src="/assets/images/hustli-logo.png" alt="Hustli Logo" className={className} />
  );
};

export default Logo; 